<template>

	<table cellpadding="0" cellspacing="0" class="data transition-fadeinup">
		<thead>
		<tr>
			<th></th>
			<th>Endpoint</th>
			<th>Browser</th>
			<th>User</th>
			<th>Created</th>
			<th></th>
		</tr>
		</thead>

		<tbody class="draggable-container">

			<tr v-for="log in logs" :key="log.id">
				<td></td>
				<td>{{ log.endpoint }}</td>
				<td>{{ convertUserAgentString(log.user_agent) }}</td>
				<td>{{ log.user }}</td>
				<td>{{ log.created }}</td>
				<td></td>
			</tr>

		</tbody>
	</table>

</template>

<script>

import xhrModule from '../../modules/xhrModule.js'

export default {
	name: 'logs',
	data () {
		return {
			logs: null
		}
	},

	created () {
		this.body = document.querySelector('body')
		this.body.classList.add('loading')
		var url = '/cms/api/log'
		xhrModule.get(url, this.getLogsCompleteHandler.bind(this))
	},

	methods: {
		getLogsCompleteHandler (data) {
			this.logs = data.data
			this.body.classList.remove('loading')
		}
	}
}

</script>
